(() => {
  'use strict';
  // Original Sculp layout interactions; commerce is handled separately.
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reducedMotion = motionQuery.matches;
  const settingsOf = widget => { try { return JSON.parse(widget.dataset.settings || '{}'); } catch { return {}; } };
  const number = (value, fallback) => Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : fallback;
  const size = (value, fallback) => number(value?.size, fallback);
  const swiperWidgets = document.querySelectorAll('[data-widget_type="media-carousel.default"], [data-widget_type="nested-carousel.default"]');

  if (typeof window.Swiper === 'function') {
    swiperWidgets.forEach(widget => {
      const settings = settingsOf(widget);
      const main = widget.querySelector('.swiper:not(.elementor-thumbnails-swiper)');
      if (!main) return;
      const thumbsEl = widget.querySelector('.elementor-thumbnails-swiper');
      if (thumbsEl) {
        // Manual gallery: one complete image followed directly by thumbnails.
        widget.classList.add('ginkgo-gallery');
        main.id = main.id || 'ginkgo-gallery-main';
        main.setAttribute('role', 'region');
        main.setAttribute('aria-roledescription', 'carrusel');
        main.setAttribute('aria-label', 'Fotos del producto Ginkgo');
        thumbsEl.setAttribute('role', 'group');
        thumbsEl.setAttribute('aria-label', 'Elegir una foto del producto');
        thumbsEl.removeAttribute('aria-roledescription');
        const originalSlides = [...main.querySelector('.swiper-wrapper').children].filter(slide => slide.classList.contains('swiper-slide') && !slide.classList.contains('swiper-slide-duplicate'));
        const thumbnailSlides = [...thumbsEl.querySelector('.swiper-wrapper').children].filter(slide => slide.classList.contains('swiper-slide'));
        const totalSlides = originalSlides.length;
        const control = (className, label, text) => {
          let button = main.querySelector(`.${className}`);
          if (!button) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = className;
            button.textContent = text;
            main.append(button);
          }
          button.setAttribute('aria-label', label);
          button.setAttribute('aria-controls', main.id);
          return button;
        };
        const previous = control('ginkgo-gallery-prev', 'Ver foto anterior', '‹');
        const next = control('ginkgo-gallery-next', 'Ver foto siguiente', '›');
        previous.classList.add('ginkgo-gallery-arrow');
        next.classList.add('ginkgo-gallery-arrow');
        main.querySelector('.ginkgo-gallery-tools')?.remove();
        originalSlides.forEach((slide, index) => {
          slide.setAttribute('aria-label', `Foto ${index + 1} de ${totalSlides}`);
        });
        thumbnailSlides.forEach((slide, index) => {
          slide.setAttribute('role', 'button');
          slide.setAttribute('tabindex', '0');
          slide.setAttribute('aria-label', `Ver foto ${index + 1} de ${totalSlides}`);
        });
        const measureGallery = () => {
          const width = widget.getBoundingClientRect().width;
          if (!width) return;
          widget.style.setProperty('--ginkgo-gallery-stage-height', `${Math.round(width)}px`);
        };
        measureGallery();
        const thumbs = new window.Swiper(thumbsEl, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          freeMode: true, watchSlidesProgress: true, slideToClickedSlide: true,
          breakpoints: {
            768: { slidesPerView: 'auto', spaceBetween: 12 },
            1025: { slidesPerView: 'auto', spaceBetween: 16 }
          },
          a11y: { enabled: true, containerMessage: 'Miniaturas del producto Ginkgo', slideRole: 'button', slideLabelMessage: 'Ver foto {{index}} de {{slidesLength}}' }
        });
        const gallery = new window.Swiper(main, {
          slidesPerView: 1,
          loop: totalSlides > 1 && settings.loop === 'yes',
          speed: reducedMotion ? 0 : 350,
          thumbs: { swiper: thumbs },
          navigation: { prevEl: previous, nextEl: next },
          autoplay: false,
          allowTouchMove: true, simulateTouch: true, grabCursor: totalSlides > 1,
          watchOverflow: true, resizeObserver: true,
          keyboard: { enabled: true, onlyInViewport: true },
          a11y: { enabled: true, containerMessage: 'Galería del producto Ginkgo', prevSlideMessage: 'Ver foto anterior', nextSlideMessage: 'Ver foto siguiente', paginationBulletMessage: 'Ver foto {{index}}' }
        });
        const syncControls = () => {
          const activeIndex = gallery.realIndex || 0;
          thumbnailSlides.forEach((slide, index) => { slide.setAttribute('aria-pressed', String(index === activeIndex)); });
          previous.hidden = next.hidden = totalSlides < 2;
        };
        thumbnailSlides.forEach((slide, index) => {
          slide.addEventListener('keydown', event => {
            if (!['Enter', ' '].includes(event.key)) return;
            event.preventDefault();
            if (gallery.params.loop) gallery.slideToLoop(index);
            else gallery.slideTo(index);
          });
        });
        gallery.on('slideChange', syncControls);
        motionQuery.addEventListener('change', () => {
          gallery.params.speed = motionQuery.matches ? 0 : 350;
          syncControls();
        });
        window.addEventListener('resize', measureGallery);
        window.visualViewport?.addEventListener('resize', measureGallery);
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(measureGallery);
          observer.observe(widget);
          const header = document.querySelector('.sculp-header');
          if (header) observer.observe(header);
        }
        document.fonts?.ready.then(measureGallery);
        syncControls();
        return;
      }
      const isVideo = widget.dataset.id === '6dbb1b0f';
      const isNested = widget.dataset.widget_type === 'nested-carousel.default';
      const desktop = number(settings.slides_to_show || settings.slides_per_view, 3);
      const tablet = number(settings.slides_to_show_tablet || settings.slides_per_view_tablet, desktop);
      const mobile = number(settings.slides_to_show_mobile || settings.slides_per_view_mobile, isNested ? 1 : 3);
      const autoplay = !reducedMotion && settings.autoplay === 'yes';
      new window.Swiper(main, {
        slidesPerView: isVideo ? 1.25 : mobile,
        slidesPerGroup: isVideo ? 1 : number(settings.slides_to_scroll_mobile, 1),
        spaceBetween: isVideo ? 12 : size(settings.image_spacing_custom_mobile || settings.space_between_mobile, size(settings.image_spacing_custom || settings.space_between, 10)),
        ...(isVideo ? { centeredSlides: false, slidesOffsetBefore: 0, slidesOffsetAfter: 0, initialSlide: 0, watchOverflow: true, resizeObserver: true } : {}),
        loop: settings.infinite === 'yes' || settings.loop === 'yes',
        speed: reducedMotion ? 0 : number(settings.speed, 500),
        autoplay: autoplay ? { delay: number(settings.autoplay_speed, 2500), disableOnInteraction: false, pauseOnMouseEnter: true } : false,
        navigation: { prevEl: widget.querySelector('.elementor-swiper-button-prev'), nextEl: widget.querySelector('.elementor-swiper-button-next') },
        pagination: { el: widget.querySelector('.swiper-pagination'), clickable: true },
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: { enabled: true, prevSlideMessage: 'Anterior', nextSlideMessage: 'Siguiente' },
        breakpoints: {
          768: { slidesPerView: isVideo ? 2 : tablet, spaceBetween: isVideo ? 16 : size(settings.image_spacing_custom_tablet || settings.space_between_tablet, size(settings.image_spacing_custom || settings.space_between, 10)) },
          1025: { slidesPerView: isVideo ? 3 : desktop, spaceBetween: isVideo ? 16 : size(settings.image_spacing_custom || settings.space_between, 10), slidesPerGroup: isVideo ? 1 : number(settings.slides_to_scroll, 1) }
        }
      });
    });
  }

  document.querySelectorAll('[data-widget_type="nested-accordion.default"]').forEach(widget => {
    if (settingsOf(widget).max_items_expended !== 'one') return;
    const details = widget.querySelectorAll('details');
    details.forEach(item => item.addEventListener('toggle', () => { if (item.open) details.forEach(other => { if (other !== item) other.open = false; }); }));
  });

  const banner = document.querySelector('[data-id="4dd2a6e1"]');
  const measureHeader = () => document.documentElement.style.setProperty('--sculp-banner-height', `${banner?.getBoundingClientRect().height || 0}px`);
  measureHeader(); window.addEventListener('resize', measureHeader);
  document.querySelectorAll('.marquee').forEach(marquee => {
    const holder = marquee.closest('#custom-bar-marquee');
    const content = marquee.querySelector('.marquee-content');
    if (!holder || !content) return;
    const count = content.children.length;
    holder.style.setProperty('--marquee-elements', String(count));
    const displayed = number(getComputedStyle(holder).getPropertyValue('--marquee-elements-displayed'), 4);
    for (let i = 0; i < Math.min(displayed, count); i++) { const copy = content.children[i].cloneNode(true); copy.setAttribute('aria-hidden', 'true'); content.appendChild(copy); }
  });

})();
